/*
  Family Hub bundle add-to-cart for the product-tile CTA experiment.

  Only handles [data-cta-exp-fh-bundle], the Variant A CTA on the Family Hub tile.
  Every other tile in Variant A posts an ordinary product form and needs no JS.

  Why this exists: adding the Family Hub device alone puts "Family Hub / Size: 15.6""
  in the cart, which is not the offer. The bundle is device + Family Hub+ plan sharing
  a _bundle_parent_sku line item property — the same payload posted by
  sections/family-hub-product.liquid and snippets/family-hub-modal-bundle-atc.liquid.
  This file deliberately mirrors that payload rather than inventing a second shape,
  because the discount is applied downstream by the subscription-zero-price Shopify
  Function which keys on those SKUs and properties.

  Behaviours copied from the modal snippet, and why:
    - Device cap: honoured via window.fhFamilyHubDeviceCount / FH_MAX_FAMILY_HUB_DEVICES
      when the PDP script has defined them. On a collection page they are usually
      absent, in which case the cap cannot be evaluated client-side and the add
      proceeds — same degradation the modal snippet already accepts.
    - Restricting discount codes: if the cart carries one, the annual plan is not
      allowed, so only the device is added.
    - Existing plan line: if the cart already holds the plan, only the device is added,
      so a second plan line is never created.

  Delegated from document so it keeps working for tiles injected later — the
  recently-viewed strip on /cart is fetched and inserted after page load.
*/
(function () {
  var ADDING_LABEL = 'Adding…';

  function cartPageUrl() {
    try {
      if (window.theme && window.theme.routes && window.theme.routes.cart_url) {
        return window.theme.routes.cart_url;
      }
    } catch (_) {}
    return '/cart';
  }

  function restrictingCodes() {
    if (Array.isArray(window.FH_RESTRICTING_DISCOUNT_CODES)) {
      return window.FH_RESTRICTING_DISCOUNT_CODES.map(function (c) {
        return String(c).trim().toUpperCase();
      }).filter(Boolean);
    }
    if (window.FH_RESTRICTING_DISCOUNT_CODE) {
      return [String(window.FH_RESTRICTING_DISCOUNT_CODE).trim().toUpperCase()];
    }
    return [];
  }

  function cartHasRestrictingCode(cart) {
    var codes = restrictingCodes();
    if (!codes.length || !cart) return false;
    return (cart.discount_codes || []).some(function (entry) {
      return entry && entry.code && codes.indexOf(String(entry.code).trim().toUpperCase()) !== -1;
    });
  }

  function atDeviceCap(cart) {
    // Only enforceable where the PDP script has exposed the counter.
    if (typeof window.fhFamilyHubDeviceCount !== 'function') return false;
    var max = typeof window.FH_MAX_FAMILY_HUB_DEVICES === 'number' ? window.FH_MAX_FAMILY_HUB_DEVICES : 5;
    return window.fhFamilyHubDeviceCount(cart) >= max;
  }

  function normalizeSellingPlanId(id) {
    if (id == null || id === '') return '';
    return String(id).replace(/^gid:\/\/shopify\/SellingPlan\//i, '');
  }

  function cartHasPlanLine(cart, planVariantId, sellingPlanId) {
    return (cart.items || []).some(function (line) {
      if (Number(line.variant_id) !== Number(planVariantId)) return false;
      if (!sellingPlanId) return !line.selling_plan_allocation;
      var sp = line.selling_plan_allocation && line.selling_plan_allocation.selling_plan;
      if (!sp || sp.id == null) return false;
      return normalizeSellingPlanId(sp.id) === normalizeSellingPlanId(sellingPlanId);
    });
  }

  function buildItems(btn, cart) {
    var deviceVariantId = Number(btn.getAttribute('data-device-variant-id') || 0);
    var planVariantId = Number(btn.getAttribute('data-plan-variant-id') || 0);
    var sellingPlanId = btn.getAttribute('data-plan-selling-plan-id') || '';
    var bundleSku = btn.getAttribute('data-bundle-sku') || '';
    if (!deviceVariantId) return null;

    var properties = bundleSku ? { _bundle_parent_sku: bundleSku } : null;
    var device = { id: deviceVariantId, quantity: 1 };
    if (properties) device.properties = properties;
    var items = [device];

    var planAllowed = planVariantId && !cartHasRestrictingCode(cart) && !cartHasPlanLine(cart, planVariantId, sellingPlanId);
    if (planAllowed) {
      var plan = { id: planVariantId, quantity: 1 };
      if (sellingPlanId) plan.selling_plan = sellingPlanId;
      if (properties) plan.properties = properties;
      items.push(plan);
    }
    return items;
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-cta-exp-fh-bundle]');
    if (!btn || btn.disabled) return;

    event.preventDefault();

    var label = btn.querySelector('.btn-text .hidden, .btn-text');
    var original = label ? label.textContent : '';
    btn.disabled = true;
    if (label) label.textContent = ADDING_LABEL;

    function fail() {
      if (label) label.textContent = original;
      btn.disabled = false;
    }

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (atDeviceCap(cart)) return fail();

        var items = buildItems(btn, cart);
        if (!items) return fail();

        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items }),
        })
          .then(function (res) { return res.ok ? res.json() : Promise.reject(res); })
          .then(function () {
            // Match the PDP and quick-view bundle flows, which send the shopper to the
            // cart page rather than relying on the drawer to render a bundle correctly.
            window.location.href = cartPageUrl();
          })
          .catch(fail);
      })
      .catch(fail);
  });
})();
